import apiRequest from '@/utils/apiRequest';

/**
 * 游戏房间（原 GameType + Room 合并）
 */
export interface GameRoom {
  id: string;
  name: string;
  description?: string;
  icon?: string;
  sort?: number;
  enabled?: boolean;
  paused?: boolean;
  chatOnly?: boolean;       // 是否为纯聊天室
  sourceId?: string;
  status?: string;
  totalBetCount?: number;
}

/**
 * 获取所有启用的游戏房间列表
 */
export async function getGameRooms(options?: { signal?: AbortSignal; cookie?: string }): Promise<GameRoom[]> {
  return apiRequest<GameRoom[]>('/gameRoom/list', {
    method: 'GET',
    ...options,
  });
}

/**
 * 获取游戏房间详情
 */
export async function getGameRoomById(id: string, options?: { signal?: AbortSignal; cookie?: string }): Promise<GameRoom> {
  return apiRequest<GameRoom>(`/gameRoom/${id}`, {
    method: 'GET',
    ...options,
  });
}

// ======== 兼容旧 API（已废弃，将在后续版本移除）========

/**
 * @deprecated 使用 GameRoom 替代
 */
export type GameType = GameRoom;


/**
 * @deprecated 使用 getGameRooms 替代
 */
export async function getGameTypes(options?: { signal?: AbortSignal; cookie?: string }): Promise<GameRoom[]> {
  return getGameRooms(options);
}

/**
 * @deprecated 使用 getGameRooms 替代
 */
export async function getRooms(options?: { signal?: AbortSignal; cookie?: string }): Promise<GameRoom[]> {
  return getGameRooms(options);
}

/**
 * @deprecated 使用 getGameRoomById 替代
 */
export async function getRoomById(id: string, options?: { signal?: AbortSignal; cookie?: string }): Promise<GameRoom> {
  return getGameRoomById(id, options);
}
